









































































import { Component, Vue, Prop, Watch } from "vue-property-decorator"
// import moment from 'moment'

@Component
export default class Run extends Vue{
    @Prop({default: []}) steps

    pause = true

    key = 0

    currentStep = 0

    update = 0

    finish = false

    getTimer(step: any){
        return (step.chrono.min * 60 + step.chrono.sec) * 1000
    }

    nextStep() {
        if(this.steps.length - 1 > this.currentStep ){
            this.currentStep ++
        } else {
            debugger
            this.finish = true
        }
    }

}
